import { useQueryClient } from "@tanstack/react-query";
import { SessionsSummary, UpdateSessionsSummaryCacheParams } from "./types";
import { BOOKED_STATUSES, DONE_STATUS, SERVICE_TO_SUMMARY_FIELDS } from "./constants";

export const useUpdateSessionsSummaryCache = () => {
    const queryClient = useQueryClient();

    const updateSessionsSummaryCache = ({ clientId, serviceId, oldStatus, newStatus }: UpdateSessionsSummaryCacheParams) => {
        if (!clientId || !serviceId) return;

        const fieldsConfig = SERVICE_TO_SUMMARY_FIELDS[serviceId];
        if (!fieldsConfig) return;

        const summaryKey = `client-sessions-summary-${clientId}`;

        queryClient.setQueriesData(
            { predicate: (query: any) => query.queryKey[0] === summaryKey },
            (oldData: SessionsSummary | undefined) => {
                if (!oldData) return oldData;

                const updatedSummary = { ...oldData };
                const wasBooked = BOOKED_STATUSES.includes(oldStatus);
                const isBooked = BOOKED_STATUSES.includes(newStatus);
                const wasDone = oldStatus === DONE_STATUS;
                const isDone = newStatus === DONE_STATUS;

                const { bookedField, doneField } = fieldsConfig;

                if (bookedField) {
                    if (wasBooked && !isBooked) (updatedSummary[bookedField] as number) -= 1;
                    if (!wasBooked && isBooked) (updatedSummary[bookedField] as number) += 1;
                }

                if (doneField) {
                    if (wasDone && !isDone) (updatedSummary[doneField] as number) -= 1;
                    if (!wasDone && isDone) (updatedSummary[doneField] as number) += 1;
                }

                return updatedSummary;
            }
        );
    };

    return { updateSessionsSummaryCache };
};

